import React, { Children } from "react";
import { useNavigate } from "react-router-dom";
import "./ServiceDetailLayout.css";

export default function ServiceDetailLayout({ title, summarySections, children }) {
  const navigate = useNavigate();

  // Trouver la section introduction pour placer le bouton juste au-dessus
  let introIndex = -1;
  const childrenArray = React.Children.toArray(children);
  introIndex = childrenArray.findIndex(
    (child) => child.props && child.props.id === "intro"
  );

  const beforeIntro = introIndex > -1 ? childrenArray.slice(0, introIndex) : childrenArray;
  const afterIntro = introIndex > -1 ? childrenArray.slice(introIndex) : [];

  return (
    <div className="service-detail-global">
      <div className="service-detail-header-row">
        <button
          className="service-back-btn animated-back-btn"
          onClick={() => navigate("/services")}
        >
          <span style={{ display: 'inline-block', verticalAlign: 'middle', marginRight: 8 }} aria-hidden="true">←</span>
          Retour aux services
        </button>
        <h1 className="service-detail-title">{title}</h1>
      </div>
      <div className="service-detail-layout">
        <aside className="service-summary">
          <div className="service-summary-title">Sommaire</div>
          <nav>
            <ul>
              {summarySections.map((section) => (
                <li key={section.id}>
                  <a href={`#${section.id}`}>{section.label}</a>
                </li>
              ))}
            </ul>
          </nav>
        </aside>
        <article className="service-content">
          {beforeIntro}
          {afterIntro}
        </article>
      </div>
    </div>
  );
}
